
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as UtilisationOrderModels from '../../models/utilisation-order/utilisation-order';
import { UtilisationOrderSearchModel } from '../../models/utilisation-order/utilisation-orderSearch';
import * as OrderStatusModels from '../../models/order/orderStatus';
import * as Models from '../../models/commonModels';

@Injectable({
  providedIn: 'root'
})

export class UtilisationOrderService {

  constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) { }

  public getList(Search: UtilisationOrderSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<UtilisationOrderModels.UtilisationOrderListModel>(`${this.environmentService.getApiURL()}/utilisation-order/list`, Search, options);
  }

  public getStatusDictionary() {
    return this.httpClient.get<OrderStatusModels.OrderStatusListModel>(`${this.environmentService.getApiURL()}/utilisation-order/status`);
  }

  public set(UtilisationOrder: Models.Request<UtilisationOrderModels.UtilisationOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<UtilisationOrderModels.UtilisationOrderObjectModel>(`${this.environmentService.getApiURL()}/utilisation-order/set`, UtilisationOrder, options);
  }

  public get(UtilisationOrder: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<UtilisationOrderModels.UtilisationOrderObjectModel>(`${this.environmentService.getApiURL()}/utilisation-order/get`, UtilisationOrder, options);
  }
}
